import React from 'react';
import { Alert, AlertContext, Form } from '../../components';
import ApiService from '../../services/api.service';
import AppService from '../../services/app.service';

interface IProps { 
    history?: any;
    id?: number;
    caption?: string;
    captionColor?: any;
    captionThin?: boolean;
    endPoint?: string;
    endPointFilter?: string;
    model: any;
    onLoad?: (data: any) => void;
    onError?: (data: any) => void;
    cardColor?: any;
    cardGradientColor?: any;
    disableBackButton?: boolean;
    disableCard?: boolean;
    children?: React.ReactNode;
}

interface IState {
    id: number;
    endPointFilter: string;
}

export default class BaseView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            id: 0,
            endPointFilter: this.props.endPointFilter || '',
        }
    }
    
    static contextType = AlertContext;

    private id = () => this.props.id === 0? '' : (this.props.id?.toString() || this.props.history?.location.state?.id || '');
    private isLoading: boolean = false;
    
    public componentDidMount() { 
        if (this.isLoading) return;
        this.isLoading = true;
        
        ApiService.get<typeof this.props.model>((this.props.endPoint||this.props.model.endPoint) + (this.props.endPointFilter || '?populate=*&filters[id]='), this.id())
        .then(rp => {
            if (rp.Status) {
                const data = rp.Data.length === 0? this.props.model.defaultValue() : new this.props.model(rp.Data[0]); 
                this.props.onLoad?.(data);
            }
            else { this.props.onError && rp.Errors? this.props.onError(rp.Errors) : Alert(this.context, rp.Messages, 'error'); }
            this.isLoading = false;
        });
    }

    public componentDidUpdate() {
        if (!this.isLoading) {
            if (this.state.id !== this.id()) {
                this.componentDidMount();
                this.setState({id: this.id()})
            }
            if (this.props.endPointFilter && this.state.endPointFilter !== this.props.endPointFilter) {
                this.componentDidMount();
                this.setState({endPointFilter: this.props.endPointFilter})
            }
        }
    }

    render() {
        return (
            <Form history={this.props.history} caption={this.props.caption || 'View ' + this.props.model.caption} captionColor={this.props.captionColor} captionThin={this.props.captionThin} buttonCaption=' ' cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>
                {this.props.children}
            </Form> 
        );
    }
}